export enum ISPValidator {
  FileMaxSize = 'maxSize',
  Duplicate = 'duplicate',
  PassMatch = 'passMatch',
  Required = 'required',
  ErrorFromBackend = 'errorFromBackend',
}

export type ISPValidationErrors = Partial<Record<ISPValidator, boolean>>;
